import axiosAuth from './axiosAuth'

export const getPipelineConfig = (controller: AbortController) =>
    axiosAuth.get<string>('/pipeline_config', {
        signal: controller.signal,
    })

export const putPipelineConfig = (configData: string) =>
    axiosAuth.put('/pipeline_config', configData)
